import { IOption } from '@netfront/ui-library';
import { formatWithThousandsSeparator } from 'utils';

import { ISelectedPlan } from './ProPlanCard.interfaces';

import { PDF_PRODUCT_ID } from '.';
import { IPlan } from '../../interfaces';

const getPlanById = (planId: number, plans: IPlan[]): IPlan | undefined => {
  return plans.find((plan) => plan.id === planId);
};

const getPlanOptions = (plans: IPlan[], productId: number): IOption[] => {
  return plans
    .filter(({ productId: planProductId }) => planProductId === productId)
    .map(({ description, id, price }) => {
      const option: IOption = {
        id,
        name: productId === PDF_PRODUCT_ID ? formatWithThousandsSeparator(Number(description), 0) : String(description),
        value: price,
      };

      return option;
    });
};

const getTotalPrice = (productPlan: ISelectedPlan): number => {
  return Number(
    Object.values(productPlan).reduce((accumulator: number, plan: IPlan | undefined) => {
      const price = plan ? plan.price : 0;
      return accumulator + price;
    }, 0),
  );
};

const getTotalPriceWithPlanId = (productPlan: ISelectedPlan, plans: IPlan[]): number => {
  if (!productPlan.plan) {
    return Number(plans[0].price);
  }
  return Number(plans.find((r) => r.id === productPlan.plan?.id)?.price);
};

export const CurrencySymbol = {
  AUD: '$',
  EUR: '€',
  USD: '$',
  YEN: '¥',
  YUAN: '¥',
  GBP: '£',
};

export { getPlanById, getPlanOptions, getTotalPrice, getTotalPriceWithPlanId };
